import React from 'react';
import { Button } from 'carbon-components-react';
import {
  AreaCustom16,
  RadioButton16,
  FlowData16,
  CloudUpload16,
  TrashCan16
} from '@carbon/icons-react';

const MapTools: React.FC<Props> = ({
  activeTool,
  removeToolLabel,
  allButtonDisabled,
  disabledRemoveTool,
  disabledUploadTool,
  showRemoveTool,
  onRemove,
  onClickTools
}) => {
  return (
    <div className="map-tools-container">
      <Button
        renderIcon={AreaCustom16}
        hasIconOnly
        kind="ghost"
        iconDescription="Shape"
        tooltipPosition="bottom"
        disabled={allButtonDisabled}
        className={`${activeTool === 'polygon' ? 'active-map-tool' : ''}`}
        onClick={() => onClickTools('polygon')}
      />
      <Button
        renderIcon={FlowData16}
        hasIconOnly
        kind="ghost"
        iconDescription="Line"
        tooltipPosition="bottom"
        disabled={allButtonDisabled}
        className={`${activeTool === 'polyline' ? 'active-map-tool' : ''}`}
        onClick={() => onClickTools('polyline')}
      />
      <Button
        renderIcon={RadioButton16}
        hasIconOnly
        kind="ghost"
        iconDescription="Circle"
        tooltipPosition="bottom"
        disabled={allButtonDisabled}
        className={`${activeTool === 'circle' ? 'active-map-tool' : ''}`}
        onClick={() => onClickTools('circle')}
      />
      <Button
        renderIcon={CloudUpload16}
        hasIconOnly
        kind="ghost"
        iconDescription="Upload"
        tooltipPosition="bottom"
        disabled={allButtonDisabled || disabledUploadTool}
        className={`${activeTool === 'upload' ? 'active-map-tool' : ''}`}
        onClick={() => onClickTools('upload')}
      />
      {showRemoveTool && (
        <Button
          renderIcon={TrashCan16}
          hasIconOnly
          kind="ghost"
          iconDescription={removeToolLabel}
          tooltipPosition="bottom"
          className={!disabledRemoveTool ? 'red' : undefined}
          disabled={disabledRemoveTool}
          onClick={() => onRemove()}
        />
      )}
    </div>
  );
};

type Props = {
  activeTool: string;
  allButtonDisabled: boolean;
  showRemoveTool: boolean;
  removeToolLabel: string;
  disabledRemoveTool: boolean;
  disabledUploadTool: boolean;
  onRemove: Function;
  onClickTools: Function;
};

MapTools.displayName = 'LodgeEnquiryMapTools';

export default React.memo(MapTools);
